<script setup>

const props = defineProps({
	color: String,
})

</script>

<template >
	<svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M10.2202 20.4862V20.4622C10.2202 19.6693 10.861 19.0205 11.6619 19.0205H21.8821V0.0378418H3.24387C1.44973 0.0378418 0 1.48757 0 3.28171V35.8966C0 38.4837 2.0985 40.5822 4.68559 40.5822H21.8821V21.92H11.6619C10.869 21.92 10.2202 21.2792 10.2202 20.4782V20.4862Z"
			:fill="`rgb(var(--color-${color}) / 1)`"
		/>
		<path
			d="M29.4512 9.6893C28.8905 9.12863 27.9774 9.12863 27.4167 9.6893C26.8561 10.25 26.8561 11.1631 27.4167 11.7237L34.7214 19.0284H21.8901V21.9279H34.7214L27.4167 29.2326C26.8561 29.7933 26.8561 30.7064 27.4167 31.2671C27.9774 31.8277 28.8905 31.8277 29.4512 31.2671L40.24 20.4782L29.4512 9.6893Z"
			:fill="`rgb(var(--color-${color}) / 1)`"
		/>
	</svg>
</template>